import LogWeightWidget from "./LogWeightWidget";

export default LogWeightWidget;
